export default __webpack_public_path__ + "static/background-dark-59802bcfd355f3f0bea4f539b803d275.png";